// для флага isApartments
export default [
  {
    text: 'Квартира',
    value: false,
  },
  {
    text: 'Апартаменты',
    value: true,
  },
];
